import React from 'react';
import { ContentLink } from '@api/types';
import { BlockContainer, Image } from '@components';
import { styled } from '@mui/material';

const ImageMediaWrapper = styled('div')``;

type ImageMediaProps = {
  url?: string;
  title?: string;
  altText?: string;
  contentLink?: ContentLink;
};

export const ImageMedia = ({ url, title, altText }: ImageMediaProps) => {
  return (
    <BlockContainer>
      <ImageMediaWrapper>
        <Image image={url} title={title} alt={altText} />
      </ImageMediaWrapper>
    </BlockContainer>
  );
};
